import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';

interface Props {
  properties: [string, string?, ((value: string) => Promise<boolean>)?][];
  isOpen: boolean;
  onClose: () => void;
}

const FileInfo: React.FC<Props> = ({ properties, isOpen, onClose }) => {
  const [renderedElements, setRenderedElements] = useState<any[]>([]);
  const [editableFields, setEditableFields] = useState<[string, string][]>([]);
  useEffect(() => {
    const fields: [string, string][] = [];
    properties.forEach((e) => {
      if (e[2]) {
        fields.push([e[0], e[1] || '']);
      }
    });
    setEditableFields(fields);
  }, [properties]);
  useEffect(() => {
    const props = properties.map((e, i) => {
      if (e[0] === '_divider') return <div className={styles.Divider} />;
      else if (e[2]) {
        return (
          <tr key={i}>
            <td>{e[0]}:</td>
            <td>
              <form
                onSubmit={(f) => {
                  f.preventDefault();
                  setIsLoading(true);
                  const func = e[2];
                  if (func) {
                    func(
                      editableFields.find((field) => field[0] === e[0])?.[1] ||
                        ''
                    ).then(() => setIsLoading(false));
                  }
                }}
              >
                <input
                  type="text"
                  value={editableFields.find((field) => field[0] === e[0])?.[1]}
                  onChange={(input) => {
                    setEditableFields((state) => {
                      const newArr = state.slice();
                      const index = newArr.findIndex((f) => f[0] === e[0]);
                      newArr[index] = [e[0], input.target.value];
                      return newArr;
                    });
                  }}
                />
              </form>
            </td>
          </tr>
        );
      } else
        return (
          <tr key={i}>
            <td>{e[0]}:</td>
            <td>{e[1]}</td>
          </tr>
        );
    });
    setRenderedElements(props);
  }, [editableFields, properties]);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <DialogTitle id="customized-dialog-title">
        Info {isLoading && <i className="fa fa-circle-o-notch fa-spin" />}
      </DialogTitle>
      <DialogContent dividers>
        <table>{renderedElements}</table>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileInfo;
